exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#menu-top {\r\n    position: absolute;\r\n    background-color: rgba(255, 255, 255, 0.9);\r\n    top: 0px;\r\n    left: 0px;\r\n    height: 60px;\r\n    padding: 10px;\r\n    width: 100%;\r\n}\r\n\r\n#navigation-bar-logo {\r\n    margin-left: 20px;\r\n    height: 40px;\r\n    width: auto;\r\n}\r\n\r\n.dropdown-item-checked::before {\r\n    position: absolute;\r\n    left: .4rem;\r\n    content: '\\2713';\r\n    font-weight: 600;\r\n  }\r\n\r\n /* .nav-link img { \r\n    padding-bottom: 4px; \r\n    height: 16px;\r\n    width: 16px;\r\n }  */\r\n\r\n.flag {\r\n    height: 16px;\r\n    width: 16px; \r\n}\r\n\r\n.nav-item .border-left {\r\n    border-left-color: #333;\r\n    border-left-style: solid;\r\n    border-left-width: 1px;\r\n    margin-left: 5px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./static-appopensalud/css/navbar.css
// module id = 1305
// module chunks = 117